import memoizeOne from 'memoize-one';
import { cascadingSelectSupportedTypes } from '../field-types/cascading-select/supported-field-types/index.tsx';
import { DEV_SUMMARY_FIELD_KEY } from '../field-types/dev-summary/constants.tsx';
import { devSummarySupportedTypes } from '../field-types/dev-summary/supported-field-types/index.tsx';
import { goalsSupportedTypes } from '../field-types/goals/supported-field-types/index.tsx';
import { groupSupportedTypes } from '../field-types/group/supported-field-types/index.tsx';
import { parentSupportedTypes } from '../field-types/parent/supported-field-types/index.tsx';
import { projectSupportedTypes } from '../field-types/project/supported-field-types/index.tsx';
import { radioSelectSupportedTypes } from '../field-types/radio-select/supported-field-types/index.tsx';
import { resolutionSupportedTypes } from '../field-types/resolution/supported-field-types/index.tsx';
import { statusCategorySupportedTypes } from '../field-types/status-category/supported-field-types/index.tsx';
import { teamSupportedTypes } from '../field-types/team/supported-field-types/index.tsx';
import { versionSupportedTypes } from '../field-types/version/supported-field-types/index.tsx';
import type { SUPPORTED_FIELD_TYPES, TOP_LEVEL_FIELD_TYPES } from './types.tsx';

// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports, @atlassian/eng-health/no-barrel-files/disallow-reexports
export type { SUPPORTED_FIELD_TYPES };

// Used in useConstant to automatic add the supported field types
export const getSupportedFieldTypes = memoizeOne(
	(isSoftwareFieldsEnabled: boolean): SUPPORTED_FIELD_TYPES[] => [
		...parentSupportedTypes,
		...teamSupportedTypes,
		...resolutionSupportedTypes,
		...groupSupportedTypes,
		...statusCategorySupportedTypes,
		...projectSupportedTypes,
		...cascadingSelectSupportedTypes,
		...radioSelectSupportedTypes,
		...goalsSupportedTypes,
		...(isSoftwareFieldsEnabled ? [...devSummarySupportedTypes, ...versionSupportedTypes] : []),
	],
);

export const isSupportedTypePredicated = (
	fieldType: string,
	isSoftwareFieldsEnabled = true,
): fieldType is SUPPORTED_FIELD_TYPES =>
	// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
	getSupportedFieldTypes(isSoftwareFieldsEnabled).includes(fieldType as SUPPORTED_FIELD_TYPES);

// top level field
const TOP_LEVEL_FIELD = [...devSummarySupportedTypes];

const isValidTopFieldType = (typename: unknown): typename is TOP_LEVEL_FIELD_TYPES => true;

export const getTopLevelFieldKey = (fieldType?: string) => {
	if (!fieldType || !isValidTopFieldType(fieldType)) {
		return null;
	}

	if (devSummarySupportedTypes.includes(fieldType)) {
		return DEV_SUMMARY_FIELD_KEY;
	}
	return null;
};

export const isTopLevelField = (fieldType?: string) => {
	if (!fieldType || !isValidTopFieldType(fieldType)) {
		return false;
	}
	return TOP_LEVEL_FIELD.includes(fieldType);
};
